import { DateFormatter } from '@repo/toolkit/date'
import { StringFormatter } from '@repo/toolkit/string'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { getEnrollment } from '../../../api/enrollments/get-enrollment'
import { getEnrollmentRemindersHistory } from '../../../api/enrollments/get-enrollment-reminders-history'
import { reminderEnumMapping } from '../../../lib/types/enums/reminder-history/reminder.enum'
import { enrollmentChildNameFields } from '../../../lib/types/fields/enrollments/enrollment'
import LabelWithText from '../../elements/label-with-text'

type Props = {
  enrollmentId: number
  className?: string
  type?: 'general' | 'accounting'
}
const RemindersHistory: React.FC<Props> = ({ className, enrollmentId, type = 'general' }) => {
  const { data } = useQuery({
    queryKey: ['enrollment-reminders-history', enrollmentId, type],
    queryFn: getEnrollmentRemindersHistory.bind(null, enrollmentId, type)
  })

  const { data: enrollment } = useQuery({
    queryKey: ['enrollment', enrollmentId, enrollmentChildNameFields],
    queryFn: () => getEnrollment(enrollmentId, enrollmentChildNameFields)
  })

  if (!data || !enrollment) return <Loader center />

  return (
    <div className={className}>
      <Typography variant="caption">
        {toFullName(enrollment.childFirstName, enrollment.childLastName, {
          options: { mode: 'lastname-firstname' }
        })}
      </Typography>
      <div className="h-2" />
      {data.length && (
        <Box className="border border-grey-light p-3 rounded-lg flex flex-col gap-2">
          {data.map((reminder) => {
            const currentIndexByType =
              data
                .filter((r) => r.reminder === reminder.reminder)
                .findIndex((r) => r.id === reminder.id) + 1
            return (
              <div className="flex items-center gap-4 justify-between" key={reminder.id}>
                <div className="flex w-10 h-10 justify-center items-center bg-blue-light rounded-sm">
                  <Typography variant="label-semibold" className="text-blue">
                    R{currentIndexByType}
                  </Typography>
                </div>
                <LabelWithText
                  label="Type de relance"
                  data={reminderEnumMapping[reminder.reminder]}
                />
                <LabelWithText
                  label="Date et Heure"
                  data={<Badge text={DateFormatter.ddMMYYYY_HHMM(reminder.sentAt)} />}
                />
                <LabelWithText
                  label="Auteur"
                  data={StringFormatter.capitalize(reminder.sendBy.firstName)}
                />
              </div>
            )
          })}
        </Box>
      )}
      <div className="h-4" />
    </div>
  )
}

export default RemindersHistory
